// Toast notifications. showToast("Added") → gold; showToast("Sold out", "error") → red.
// Renders into #toast-container (in _Layout); creates it when a page lacks one.

export type ToastType = 'error' | 'success' | undefined;

function container(): HTMLElement {
    let c = document.getElementById('toast-container');
    if (!c) {
        c = document.createElement('div');
        c.id = 'toast-container';
        c.className = 'toast-container';
        c.setAttribute('aria-live', 'polite');
        document.body.appendChild(c);
    }
    return c;
}

export interface ToastAction { label: string; onClick: () => void; }

/** An action ("Change details") turns the toast into a short-lived button bar; it stays a little longer. */
export function showToast(message: string, type?: ToastType, durationMs = 3000, action?: ToastAction): void {
    const c = container();
    const toast = document.createElement('div');
    toast.className = 'toast' + (type === 'error' ? ' toast-error' : type === 'success' ? ' toast-success' : '');
    toast.setAttribute('role', 'status');
    toast.textContent = message;
    if (action) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'toast-action';
        btn.textContent = action.label;
        btn.addEventListener('click', () => { toast.remove(); action.onClick(); });
        toast.appendChild(btn);
        durationMs = Math.max(durationMs, 6000);
    }
    c.appendChild(toast);

    setTimeout(() => {
        toast.classList.add('toast-hide');
        let removed = false;
        const remove = () => { if (!removed && toast.parentNode) { removed = true; toast.parentNode.removeChild(toast); } };
        toast.addEventListener('animationend', remove);
        setTimeout(remove, 600); // no animation support / prefers-reduced-motion
    }, durationMs);
}
